import fetch from "auth/FetchInterceptor";

const indicadoresService = {};

indicadoresService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/goals",
		method: "get",
		params,
	});
};

indicadoresService.getV2Enabled = function (companyId) {
	return fetch({
		url: "/v1/rest/indicadores-v2-enabled",
		method: "get",
		params: companyId ? { company_id: companyId } : {},
	});
};

indicadoresService.post = function (data) {
	return fetch({
		url: "/v1/rest/goal",
		method: "post",
		data: data,
	});
};

indicadoresService.postCopyGoal= function (data, id) {
	return fetch({
		url: `/v1/rest/goal-in-company-schema/${id}`,
		method: "post",
		data: data,
	});
};

indicadoresService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/goal/${id}`,
		method: "put",
		data: data,
	});
};

indicadoresService.delete = function (id) {
	return fetch({
		url: `/v1/rest/goal/${id}`,
		method: "delete",
	});
};

indicadoresService.getLaunch = function (id, year) {
	return fetch({
		url: `/v1/rest/goal-config-values/${id}/${year}`,
		method: "get",
	});
};

indicadoresService.getLaunchWithTotals = function (id, year) {
	return fetch({
		url: `/v1/rest/goal-config-values-with-totals/${id}/${year}`,
		method: "get",
	});
};

indicadoresService.updateLaunch = function (id, data) {
	return fetch({
		url: `/v1/rest/goal-config-value/${id}`,
		method: "post",
		data: data,
	});
};

indicadoresService.getVariableLaunch = function (year) {
	return fetch({
		url: `/v1/rest/goals-variables-value/${year}`,
		method: "get",
	});
};

indicadoresService.updateVariableLaunch = function (data) {
	return fetch({
		url: `/v1/rest/goals-variables-value`,
		method: "post",
		data,
	});
};

indicadoresService.getVariables = function () {
	return fetch({
		url: "/v1/rest/goals-variables",
		method: "get",
	});
};

indicadoresService.createVariable = function (data) {
	return fetch({
		url: "/v1/rest/goals-variables",
		method: "post",
		data,
	});
};

indicadoresService.updateVariable = function (id, data) {
	return fetch({
		url: `/v1/rest/goals-variables/${id}`,
		method: "put",
		data,
	});
};

indicadoresService.getVariableUsage = function (id) {
	return fetch({
		url: `/v1/rest/goals-variables/${id}/usage`,
		method: "get",
	});
};

indicadoresService.deleteVariable = function (id) {
	return fetch({
		url: `/v1/rest/goals-variables/${id}`,
		method: "delete",
	});
};

indicadoresService.getById = function (id) {
	return fetch({
		url: `/v1/rest/goal/${id}`,
		method: "get",
	});
};

indicadoresService.getVariablesConfig = function (goalsId) {
	return fetch({
		url: `/v1/rest/goals-variables-config/${goalsId}`,
		method: "get",
	});
};

indicadoresService.addVariableConfig = function (data) {
	return fetch({
		url: "/v1/rest/goals-variables-config",
		method: "post",
		data,
	});
};

indicadoresService.updateVariableConfig = function (id, data) {
	return fetch({
		url: `/v1/rest/goals-variables-config/${id}`,
		method: "put",
		data,
	});
};

indicadoresService.removeVariableConfig = function (id) {
	return fetch({
		url: `/v1/rest/goals-variables-config/${id}`,
		method: "delete",
	});
};

indicadoresService.postCopyVariableConfigs = function (company_id, data) {
	return fetch({
		url: `/v1/rest/goals-variables-config-in-company-schema/${company_id}`,
		method: "post",
		data,
	});
};

export default indicadoresService;
